var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "detail-summay-containter",
      attrs: { id: "addendum-detail-content" },
    },
    [
      _c(
        "tender-head",
        {
          ref: "tenderEditHead",
          attrs: { tenderGeneral: _vm.currentTender.general },
        },
        [
          _vm.isPicView || _vm.isRepresentative
            ? [
                !_vm.isEditing
                  ? _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "note",
                            rawName: "v-note",
                            value: {
                              text: _vm.noteText,
                              enable: !_vm.editable,
                            },
                            expression: "{text:noteText, enable:!editable}",
                          },
                        ],
                        staticClass: "btn btn--darkblue",
                        attrs: { type: "button", disabled: !_vm.editable },
                        on: {
                          click: function ($event) {
                            return _vm.goEdit()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.edit")))]
                    )
                  : [
                      _vm.isPicView ? _c("cancel-addendum") : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            { name: "hkldreset", rawName: "v-hkldreset" },
                          ],
                          staticClass: "btn btn--orange nav-btn-top",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.saveAndToView()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.preview_save")))]
                      ),
                    ],
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "detail-summay-accordion-container" }, [
        _c(
          "ul",
          {
            staticClass: "accordion accordion-main accordion-customize",
            attrs: {
              id: "detail-summay-accordion",
              "data-accordion": "",
              "data-deep-link": "true",
              "data-allow-all-closed": "true",
              "data-multi-expand": "true",
              "data-update-history": "true",
              "data-deep-link-smudge": "500",
            },
          },
          [
            _c(
              "li",
              {
                staticClass: "accordion-item",
                attrs: { "data-accordion-item": "" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "accordion-title",
                    attrs: { href: "#detail-summary-tabs" },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("summary.name")))])]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "accordion-content",
                    attrs: {
                      id: "detail-summary-tabs",
                      "data-tab-content": "",
                    },
                  },
                  [_c("div", [_c("Addendum", { attrs: { isBid: false } })], 1)]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "accordion-item is-active",
                attrs: { "data-accordion-item": "" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "accordion-title",
                    attrs: { href: "#detail-summary-tabs" },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("tender.detail")))])]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "accordion-content detail-summary-tabs",
                    attrs: {
                      id: "detail-summary-tabs",
                      "data-tab-content": "",
                    },
                  },
                  [
                    _c(
                      "div",
                      [
                        _vm.isEditing
                          ? _c(
                              "TenderTabsContainer",
                              {
                                attrs: {
                                  isTender: _vm.isTender,
                                  tabsInvalid: _vm.tabsInvalid,
                                },
                              },
                              [
                                _c("General", {
                                  ref: "general_tab",
                                  attrs: {
                                    slot: "general",
                                    isTender: _vm.isTender,
                                  },
                                  slot: "general",
                                }),
                                _vm._v(" "),
                                _c("ScopeOfWorkEditor", {
                                  attrs: { slot: "scopeOfWork" },
                                  slot: "scopeOfWork",
                                }),
                                _vm._v(" "),
                                _c("ItemsServices", {
                                  ref: "items_services_tab",
                                  attrs: {
                                    slot: "itemServices",
                                    lockItems: _vm.lockItems,
                                  },
                                  slot: "itemServices",
                                }),
                                _vm._v(" "),
                                _c("FileUpload", {
                                  ref: "file_uploader_tab",
                                  attrs: {
                                    slot: "fileUpload",
                                    attachment: _vm.attachment,
                                    showTenderHints: true,
                                    metaData: { category: undefined },
                                    resourceId: _vm.currentTender.general.id,
                                    overallDescription: true,
                                  },
                                  on: {
                                    "update:attachment": function ($event) {
                                      _vm.attachment = $event
                                    },
                                  },
                                  slot: "fileUpload",
                                }),
                                _vm._v(" "),
                                _c("TermsConditions", {
                                  attrs: {
                                    slot: "termsConditions",
                                    isTender: _vm.isTender,
                                    zipName: _vm.zipNames.terms,
                                    tenderId: _vm.tenderId,
                                  },
                                  slot: "termsConditions",
                                }),
                                _vm._v(" "),
                                _vm.isPicView || _vm.isRepresentative
                                  ? [
                                      _vm.isPicView
                                        ? _c("cancel-addendum", {
                                            attrs: {
                                              className:
                                                "btn btn--darkblue mini-btn",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          directives: [
                                            {
                                              name: "hkldreset",
                                              rawName: "v-hkldreset",
                                            },
                                          ],
                                          staticClass:
                                            "btn btn--orange nav-btn-top mini-btn",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.saveAndToView()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("action.preview_save")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _c(
                              "TenderTabsContainer",
                              { attrs: { isTender: _vm.isTender } },
                              [
                                _vm.isPicView || _vm.isRepresentative
                                  ? _c(
                                      "button",
                                      {
                                        directives: [
                                          {
                                            name: "note",
                                            rawName: "v-note",
                                            value: {
                                              text: _vm.noteText,
                                              enable: !_vm.editable,
                                            },
                                            expression:
                                              "{text:noteText, enable:!editable}",
                                          },
                                        ],
                                        staticClass: "btn btn--darkblue",
                                        attrs: {
                                          type: "button",
                                          disabled: !_vm.editable,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.goEdit()
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("action.edit")))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.tenderId === _vm.currentTender.general.id
                                  ? _c("GeneralView", {
                                      attrs: { slot: "general" },
                                      slot: "general",
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("ScopeOfWork", {
                                  attrs: { slot: "scopeOfWork" },
                                  slot: "scopeOfWork",
                                }),
                                _vm._v(" "),
                                _c("ItemsServicesView", {
                                  attrs: { slot: "itemServices" },
                                  slot: "itemServices",
                                }),
                                _vm._v(" "),
                                _c("Attachments", {
                                  attrs: {
                                    slot: "fileUpload",
                                    files: _vm.attachmentFiles,
                                    description: _vm.attachment.description,
                                    zipName: _vm.zipNames.attachments,
                                  },
                                  slot: "fileUpload",
                                }),
                                _vm._v(" "),
                                _c("TermsConditions", {
                                  attrs: {
                                    slot: "termsConditions",
                                    tenderId: _vm.tenderId,
                                    isTender: _vm.isTender,
                                    zipName: _vm.zipNames.terms,
                                  },
                                  slot: "termsConditions",
                                }),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("TenderRepresentative", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTenderRep,
                expression: "showTenderRep",
              },
            ],
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }